import styled from 'styled-components/macro';

import { blue } from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const InputContainer = styled.div`
  display: flex;
  height: ${({ msgFooter, invalid }) =>
    msgFooter || invalid ? '72px' : '50px'};

  ${({ msgFooter, invalid }) => msgFooter && invalid && 'height: 106px;'}
  max-height: 120px;
  color: ${blue};
  position: relative;
  width: 100%;
  z-index: ${({ zIndex }) => zIndex};
  flex-direction: column;
`;

export const Input = styled.input`
  flex-grow: 1;
  width: 100%;
  font-family: inherit;
  padding: 10px 8px 0;
  min-height: 50px;
  color: ${({ invalid, theme }) => (invalid ? theme.invalidColor : 'inherit')};
  font-weight: 500;
  letter-spacing: 0.4px;
  ${fontSize(12)};
  border: 1px solid
    ${({ invalid, theme }) =>
      invalid ? theme.invalidColor : theme.validInputBorder};
  ${media.desktop`
    padding: 15px 19px 0;
    ${fontSize(14)};
  `};
  &:disabled {
    background-color: #ccc;
  }
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.invalidColor};
  padding-top: 10px;
  ${fontSize(10)};
`;
